import { gql } from '@apollo/client'
import { brandRowFieldsFragment } from 'modules/brands/list/queries/getDiscoveryBrands'

export const productDropFragment = gql`
  ${brandRowFieldsFragment}

  fragment ProductFields on Product {
    id
    name
    minPrice
    currency
    defaultImageUrl
    description
    isSoldOut
    extraInfoLink
    extraInfoLabel
    variantsMap {
      name
      values {
        name
        sku_ids
      }
    }
    variants {
      id
      name
      sku
      salePrice
      retailPrice
      inStock
      productId
      limitToSupertesters
      variantValues {
        variant
        value
      }
      primaryImageUrl
    }
  }

  fragment ProductDropFields on ProductDrop {
    id
    isPromoted
    dropsAt
    hasDropped
    heroImageFullPath
    isSoldOut
    nextDropAt
    shipsTo
    backgroundColor
    isVisible
    product {
      ...ProductFields
    }
    brand {
      ...BrandRowFields
    }
  }
`
